import React from 'react';
import { SigningLink } from '../../../../../../../entities/v1/applicant_tracking/SigningLink';
import { AvatarWithName } from '../../../../../../../components/AvatarWithName';

interface PropTypes {
  signingLinks: SigningLink[];
}

export function Signatories(props: PropTypes) {
  const signatory = props.signingLinks.find(
    (signingLink) => signingLink?.userId,
  );
  if (!signatory || !signatory.user) return null;

  return (
    <div className='mb-2'>
      <h5>Company Signatories</h5>
      <AvatarWithName
        name={signatory.user.name}
        type={'initials'}
        maxChars={25}
      />
    </div>
  );
}
